/*
 * "DialogForm" purpose is to share common vars, default values, methods & main layout for mdDialog boxes.
 *
 * To be defined in the extended controller :
 * - title: dialog box header title
 * - partial: name of partial to be included for dialog box content
 * - preventSubmit (optional): `true` if you need to disable submit action (on init, while saving data, etc)
 * - onSubmit(): method called on form submit
 */
export class DialogFormController {

    public static $inject: string[] = [
        "$mdDialog",
        "$mdMedia",
        "toaster"
    ];

    public form: any;
    public partial: string;
    public preventSubmit: boolean = false;
    public title: string;
    public cancelLabel: string = "annuler";
    public submitLabel: string = "envoyer";

    constructor(
        protected $mdDialog: ng.material.IDialogService,
        public $mdMedia: ng.material.IMedia,
        protected toaster: any
    ) {}

    public cancel() {
        this.$mdDialog.cancel();
    }
}
